import axiosClient from "../../utils/axiosInstance";

export const getCourseTutors = (page: number) => {
  const response = axiosClient().get(`/public/get-course-authors/${page}`);
  return response;
};
